import { render, staticRenderFns } from "./ContBtn.vue?vue&type=template&id=7bed7502"
import script from "./ContBtn.vue?vue&type=script&lang=js"
export * from "./ContBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports